import {
    Component,
    OnInit,
    ChangeDetectorRef,
    NgZone,
    OnDestroy,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { ICalendarDateActive, IMY } from 'src/app/interfaces/calendar';
import { IRnumbList } from 'src/app/interfaces/rnumb.interface';
import { LoadService } from 'src/app/services/application/load.service';
import { CalendarService } from 'src/app/services/calendar.service';
import { RnumbService } from 'src/app/services/rnumb.service';
import { strToDate } from '../application/global.function';
import { DicomViewModalComponent } from './dicom-view-modal/dicom-view-modal.component';
import { lastValueFrom } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

@Component({
    selector: 'app-history',
    templateUrl: './history.component.html',
    styleUrls: ['./history.component.scss'],
})
export class HistoryComponent implements OnInit, OnDestroy {
    // MOBILE COPY
    statusTab = 0; // Тип закладки (0-Предстоящие, 1- Завершенные)
    sDate: string = '';
    isNotDate: boolean = false; // Нет данных
    dateSelectMyRec = ''; // выбранная дата в Предстоящие
    dateSelect = ''; // выбранная дата в Завер
    loadingRnumbList = false;

    rnumbPages: IRnumbList[] = [];

    myrec_count: number = 0;

    countRecToHeigh = 10;

    classApplied = false;

    private _setting: any;
    _selectedDate: string = ''; // выбранная дата

    rnumbList: IRnumbList[] = [];
    filteredRnumbList: IRnumbList[] = [];
    closeResult: string = '';
    modalReference!: NgbModalRef;

    // PC COPY
    blockBodystyleHeight = { height: 'auto' };
    blockCalendaryStyleHeight = { height: 'auto' };
    outletH: number = 0;
    selectedDateInCalenadr: string = '';
    isMobileFlilterOpen: boolean = false;
    isMobile: boolean = false;
    filterChecked: boolean = false;

    set selectedDate(value: string) {
        this._selectedDate = value;
        this.setFilterDate(this._selectedDate);
        this.selectedDateInCalenadr = moment(value).format('DD MMMM');
    }
    get selectedDate() {
        return this._selectedDate;
    }

    constructor(
        private cs: CalendarService,
        private load: LoadService,
        private title: Title,
        private rs: RnumbService,
        private modalService: NgbModal,
        private cdr: ChangeDetectorRef,
        private router: Router,
        private route: ActivatedRoute,
    ) {
        this._setting = this.load.configData.pages.history;
        if (this._setting && this._setting.title) {
            this.title.setTitle(this._setting.title);
        }
    }

    mobileFilterButtonClass: string = '';
    ngOnInit(): void {
        this.changeTab(0); // Переход к предстоящим
        // this.getRnumbList();
        this.updateActiveFiltersState();

        this.isMobile = window.innerWidth <= 767;
        window.addEventListener('resize', () => {
            this.isMobile = window.innerWidth <= 767;
            this.cdr.detectChanges();
        });
        this.calculateMobileFilterButtonPosition();
        window.addEventListener(
            'resize',
            this.calculateMobileFilterButtonPosition,
        );
        this.route.queryParams.subscribe((params) => {
            if (params['selectedAppointmentId']) {
                // Set the tab if specified
                if (params['tab'] !== undefined) {
                    this.changeTab(Number(params['tab']));
                }

                // Store the appointment ID to be processed after list loads
                sessionStorage.setItem(
                    'selectedAppointmentId',
                    params['selectedAppointmentId'],
                );
            }
        });
    }

    ngOnDestroy() {
        window.removeEventListener(
            'resize',
            this.calculateMobileFilterButtonPosition,
        );
    }

    calculateMobileFilterButtonPosition = () => {
        const screenWidth = window.innerWidth;
        const centerElementWidth = 280; // ширина центрального элемента
        const iconWidth = 26; // ширина иконки

        // Вычисляем доступное пространство справа от центрального элемента
        const rightSpace = (screenWidth - centerElementWidth) / 2;

        // Позиционируем иконку по центру этого пространства
        // Учитываем половину ширины самой иконки для точного центрирования
        const offsetFromRight = rightSpace / 2 - iconWidth / 2;

        if (offsetFromRight > 0) {
            this.mobileFilterButtonClass = `mobile-filter__button--offset-${Math.round(
                offsetFromRight,
            )}`;
        } else {
            this.mobileFilterButtonClass = '';
        }
    };

    // ngAfterViewInit(): void {
    //     // откладываем изменения на следующий тик JS
    //     setTimeout(() => {
    //         this.changeTab(0);
    //         this.getRnumbList();
    //     }, 0);
    //     this.ngZone.run(() => {
    //         this.changeTab(0);
    //         this.getRnumbList();
    //     });
    // }

    async getRnumbList() {
        let dt: ICalendarDateActive[] = [];
        this.rnumbList = [];
        this.filteredRnumbList = [];
        this.loadingRnumbList = true;
        this.cdr.markForCheck();

        try {
            // todo: нужно сначала переделать процедуру, чтобы она получала входные даты для фильтрации и пагинации. Как сделано на остальных страницах
            const res = await lastValueFrom(this.rs.getRnumbList());
            this.rnumbList = res;

            this.rnumbList.forEach((item) => {
                item.beginDate = strToDate(item.dat_bgn);
                item.endDate = strToDate(item.dat_end);

                dt.push({
                    date: Number(moment(item.beginDate).format('YYYYMMDD')),
                });
            });

            this.rnumbList.sort(
                (a, b) => a.beginDate?.getTime()! - b.beginDate?.getTime()!,
            );

            // todo: избавиться от filteredRnumbList
            this.filteredRnumbList = this.rnumbList;
            this.rnumbPages = this.filteredRnumbList;
            this.cdr.detectChanges();
        } catch (error) {
            dt.push({ date: Number(moment().format('YYYYMMDD')) });
            this.cdr.detectChanges();
        } finally {
            setTimeout(() => {
                this.loadingRnumbList = false;
                this.updateActiveFiltersState();
                this.cdr.markForCheck();
            }, 0);
        }
    }

    changeTab(n: number) {
        this.isNotDate = false;
        this.statusTab = n;
        this.sDate = ''; // Обнуляем выбранную дату
        this.updateActiveFiltersState();
        this.cdr.markForCheck(); // Use markForCheck instead of detectChanges
    }
    getSliderPosition(): string {
        return this.statusTab === 0 ? 'translateX(0%)' : 'translateX(100%)';
    }

    setFilterDate(dt: string) {
        if (dt.length == 0) {
            this.filteredRnumbList = this.rnumbList;
        } else {
            this.filteredRnumbList = this.rnumbList.filter(
                (item) => moment(item.beginDate).format('YYYY-MM-DD') === dt,
            );
        }
    }

    calendarClick(dt: string) {
        if (this.sDate != dt) {
            this.sDate = dt;

            if (this.statusTab == 0) {
                // Предстоящие
                this.dateSelectMyRec = dt;
            } else {
                // Завершенные
                this.dateSelect = dt;
            }
            this.cs.setSelectedDate(dt);
            this.setFilterDate(dt);
        } else {
            this.cs.notSelect(true); // Передаем событие
            this.sDate = '';
        }
    }

    dateGet(event: ICalendarDateActive[]) {
        this.isNotDate = false;
        //
        let maxDT: IMY;
        const calendarDate = event?.sort((a, b) => a.date - b.date);
        let count = 3;
        if (event && event.length > 0) {
            // Данные есть
            let s: string = calendarDate[0].date + '';
            const cdYear = Number(s[0] + s[1] + s[2] + s[3]);
            const cdMounth = Number(s[4] + s[5]);
            maxDT = { m: cdMounth, y: cdYear };
            if (this.outletH < 930) {
                count = 2;
            }
            this.cs.setParams({
                year_begin: cdYear,
                mounth_begin: cdMounth,
                count: count,
                cdActive: calendarDate,
                orderByStart: false,
                MaxDate: maxDT,
                selectDate: this.dateSelect,
            });
        } else {
            // Нет данных
            this.isNotDate = true;
            let dt = new Date(); // По текущей дате
            maxDT = { m: dt.getMonth(), y: dt.getFullYear() };
            const interval = setInterval(() => {
                if (this.outletH > 0) {
                    if (this.outletH < 930) {
                        count = 2;
                    }
                    this.cs.setParams({
                        year_begin: dt.getFullYear(),
                        mounth_begin: dt.getMonth(),
                        count: count,
                        cdActive: [],
                        orderByStart: true,
                        MaxDate: maxDT,
                        selectDate: this.dateSelect,
                    });
                    clearInterval(interval);
                }
            }, 100);
        }
    }

    dateGetMyRec(event: ICalendarDateActive[]) {
        this.myrec_count = event.length; // Количество моих посещений
        let count = 2;
        let minDT: IMY;
        this.isNotDate = false;
        if (event && event.length > 0) {
            // Данные есть
            const calendarDate = event?.sort((a, b) => a.date - b.date);

            let s: string = calendarDate[0].date + '';
            const cdYear = Number(s[0] + s[1] + s[2] + s[3]);
            const cdMounth = Number(s[4] + s[5]);
            minDT = { m: cdMounth, y: cdYear };
            this.cs.setParams({
                year_begin: cdYear,
                mounth_begin: cdMounth,
                count: count,
                cdActive: calendarDate,
                orderByStart: true,
                MinDate: minDT,
                selectDate: this.dateSelectMyRec,
            });
        } else {
            // Нет данных
            this.isNotDate = true;
            let dt = new Date(); // По текущей дате
            minDT = { m: dt.getMonth(), y: dt.getFullYear() };
            this.cs.setParams({
                year_begin: dt.getFullYear(),
                mounth_begin: dt.getMonth(),
                count: count,
                cdActive: [],
                orderByStart: true,
                MinDate: minDT,
                selectDate: this.dateSelectMyRec,
            });
        }
    }

    openDicomModal(studyID: string, e: MouseEvent) {
        e.stopPropagation();
        const modal = this.modalService.open(DicomViewModalComponent, {
            backdropClass: 'dicom-modal__backdrop',
            animation: false,
        });
        modal.componentInstance.studyID = studyID;
    }

    // get hasActiveFilters(): boolean {
    //     // Проверяем наличие элемента с классом has-active-filters
    //     const indicator = document.querySelector('.has-active-filters');
    //     return indicator !== null;
    // }

    // Add a class property to track active filters
    private _hasActiveFilters: boolean = false;

    // Update the getter to use the property instead of querying DOM
    get hasActiveFilters(): boolean {
        return this._hasActiveFilters;
    }

    updateActiveFiltersState() {
        // Use setTimeout to move DOM query outside of change detection cycle
        setTimeout(() => {
            const indicator = document.querySelector('.has-active-filters');
            this._hasActiveFilters = indicator !== null;

            this.cdr.markForCheck();
        }, 0);
    }

    // Add a setter for hasActiveFilters
    set hasActiveFilters(value: boolean) {
        this._hasActiveFilters = value;
        this.cdr.markForCheck();
    }

    // Update the mobileFilterHandler method
    mobileFilterHandler(event?: boolean) {
        if (event !== undefined) {
            // this.filterChecked = event;
            this.filterChecked = !this.filterChecked;

            this._hasActiveFilters = event; // Use the private property directly
        } else {
            this.filterChecked = !this.filterChecked;
        }
    }
}
